import React, {useEffect, useState} from "react";
import {Link, Route, Routes, useNavigate} from "react-router-dom";
import Dashboard from "../pages/admin-pages/Dashboard";
import Users from "../pages/admin-pages/Users";
import Requests from "../pages/admin-pages/Requests";
import Trips from "../pages/admin-pages/Trips";
import {googleLogout} from '@react-oauth/google';
import Wallet from "../pages/admin-pages/Wallet";
import Settings from "../pages/admin-pages/Settings";
import {apiPath, serverToken} from "../utils/api";
import axios from "axios";
import {CgSpinner} from "react-icons/cg";

export default function Sidebar() {

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [profile, setProfile] = useState(false);
    const [data, setData] = useState(null);

    const user = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/get-sidebar-badge-counter', {headers})
            .then(
                res => {
                    setData(res.data);
                    setIsLoading(false);
                }
            ).catch(err => {
            setIsLoading(false);
        });

    }, []);

    useEffect(() => {
        setInterval(() => {
            getData()
        }, 15000);
    }, []);


    const getData = async () => {

        const headers = {
            'Authorization': serverToken,
        };

        await axios.get(apiPath + '/get-sidebar-badge-counter', {headers})
            .then(
                res => {
                    setData(res.data);
                }
            ).catch(err => {
            });
    };

    if (isLoading) {
        return (
            <div className="container h-screen  mx-auto flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    const getFirstWord = (str) => {
        let strArr = str.split(" ");
        if (strArr.length > 0) {
            return strArr[0];
        }
        return "";
    }

    const handleLogout = () => {
        googleLogout();
        localStorage.removeItem("G_ID");
        localStorage.removeItem("user");
        navigate('/');
    }

    return (
        <>
            <div className="w-full h-full">
                <div className="flex flex-no-wrap">
                    {/* Sidebar starts */}
                    <div className="absolute lg:relative w-64 h-screen bg-white border hidden lg:block">

                        <ul aria-orientation="vertical" className="">

                            <Link to='estadisticas'>
                                <li className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                    <div className="flex items-center">
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                 strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                      d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"/>
                                            </svg>

                                        </div>
                                        <span className="ml-2">Estadísticas</span>
                                    </div>
                                </li>
                            </Link>

                            <Link to='usuarios'>
                                <li className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                    <div className="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"/>
                                        </svg>

                                        <span className="ml-2">Usuarios</span>
                                    </div>
                                </li>
                            </Link>

                            <Link to='solicitudes'>
                                <li className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                    <div className="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"/>
                                        </svg>

                                        <span className="ml-2">Solicitudes</span>
                                        {data.trips_pending > 0 ? <span
                                            className="ml-2 bg-sky-400 rounded-full px-2 text-sm text-white">{data.trips_pending}</span> : ""}
                                    </div>
                                </li>
                            </Link>

                            <Link to='viajes'>
                                <li className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                    <div className="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"/>
                                        </svg>

                                        <span className="ml-2">Viajes</span>
                                    </div>
                                </li>
                            </Link>

                            <Link to='billetera'>
                                <li className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                    <div className="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3"/>
                                        </svg>

                                        <span className="ml-2">Billetera</span>
                                        {data.wallet_pending > 0 ? <span
                                            className="ml-2 bg-sky-400 rounded-full px-2 text-sm text-white">{data.wallet_pending}</span> : ""}
                                    </div>
                                </li>
                            </Link>

                            <Link to='ajustes'>
                                <li className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                    <div className="flex items-center">

                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                             strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"/>
                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                        </svg>


                                        <span className="ml-2">Ajustes</span>
                                    </div>
                                </li>
                            </Link>

                        </ul>
                    </div>
                    {/*Mobile responsive sidebar*/}
                    <div
                        className={show ? "w-full h-full absolute z-40  transform  translate-x-0 " : "   w-full h-full absolute z-40  transform -translate-x-full"}
                        id="mobile-nav">
                        <div className="bg-gray-800 opacity-50 absolute h-full w-full lg:hidden"
                             onClick={() => setShow(!show)}/>
                        <div
                            className="absolute z-40 sm:relative w-64 md:w-96 shadow pb-4 bg-white lg:hidden transition duration-150 ease-in-out h-full">
                            <div className="flex flex-col justify-between h-full w-full">
                                <div>
                                    <div className="flex items-center justify-between px-8">
                                        <div className="h-16 w-full flex flex-col items-start">
                                        </div>
                                        <div id="closeSideBar"
                                             className="flex items-center justify-center h-10 w-10"
                                             onClick={() => setShow(!show)}>
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                 className="icon icon-tabler icon-tabler-x" width={20} height={20}
                                                 viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                                                 fill="none"
                                                 strokeLinecap="round" strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z"/>
                                                <line x1={18} y1={6} x2={6} y2={18}/>
                                                <line x1={6} y1={6} x2={18} y2={18}/>
                                            </svg>
                                        </div>
                                    </div>
                                    <ul aria-orientation="vertical">
                                        <Link to='estadisticas'>
                                            <li onClick={() => setShow(false)}
                                                className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                                <div className="flex items-center">
                                                    <div className="w-6 h-6 md:w-8 md:h-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24" strokeWidth={1.5}
                                                             stroke="currentColor"
                                                             className="w-5 h-5">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"/>
                                                        </svg>
                                                    </div>
                                                    <span
                                                        className="ml-2 xl:text-base md:text-2xl text-base">Estadísticas</span>
                                                </div>
                                            </li>
                                        </Link>
                                        <Link to='usuarios'>
                                            <li onClick={() => setShow(false)}
                                                className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                                <div className="flex items-center">
                                                    <div className="w-6 h-6 md:w-8 md:h-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24" strokeWidth={1.5}
                                                             stroke="currentColor"
                                                             className="w-5 h-5">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"/>
                                                        </svg>
                                                    </div>
                                                    <span
                                                        className="ml-2 xl:text-base md:text-2xl text-base">Usuarios</span>
                                                </div>
                                            </li>
                                        </Link>
                                        <Link to='solicitudes'>
                                            <li onClick={() => setShow(false)}
                                                className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                                <div className="flex items-center">
                                                    <div className="w-6 h-6 md:w-8 md:h-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24" strokeWidth={1.5}
                                                             stroke="currentColor"
                                                             className="w-5 h-5">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"/>
                                                        </svg>
                                                    </div>
                                                    <span
                                                        className="ml-2 xl:text-base md:text-2xl text-base">Solicitudes</span>
                                                    {data.trips_pending > 0 ? <span
                                                        className="ml-2 bg-sky-400 rounded-full px-2 text-sm text-white">{data.trips_pending}</span> : ""}


                                                </div>
                                            </li>
                                        </Link>
                                        <Link to='viajes'>
                                            <li onClick={() => setShow(false)}
                                                className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                                <div className="flex items-center">
                                                    <div className="w-6 h-6 md:w-8 md:h-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24" strokeWidth={1.5}
                                                             stroke="currentColor"
                                                             className="w-5 h-5">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"/>
                                                        </svg>
                                                    </div>
                                                    <span
                                                        className="ml-2 xl:text-base md:text-2xl text-base">Viajes</span>

                                                </div>
                                            </li>
                                        </Link>
                                        <Link to='billetera'>
                                            <li onClick={() => setShow(false)}
                                                className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">
                                                <div className="flex items-center">
                                                    <div className="w-6 h-6 md:w-8 md:h-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24"
                                                             strokeWidth={1.5} stroke="currentColor"
                                                             className="w-5 h-5">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 9m18 0V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v3"/>
                                                        </svg>

                                                    </div>
                                                    <span
                                                        className="ml-2 xl:text-base md:text-2xl text-base">Billetera</span>

                                                    {data.wallet_pending > 0 ? <span
                                                        className="ml-2 bg-sky-400 rounded-full px-2  text-sm text-white">{data.wallet_pending}</span> : ""}

                                                </div>
                                            </li>
                                        </Link>

                                        <Link to='ajustes'>

                                            <li onClick={() => setShow(false)}
                                                className="cursor-pointer text-gray-500 text-sm mt-4 mb-4 py-2 px-3 hover:bg-gray-100 rounded-lg mx-3 focus:text-amber-400 focus:outline-none">

                                                <div className="flex items-center">

                                                    <div className="w-6 h-6 md:w-8 md:h-8">

                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                             viewBox="0 0 24 24" strokeWidth={1.5}
                                                             stroke="currentColor" className="w-5 h-5">
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"/>
                                                            <path strokeLinecap="round" strokeLinejoin="round"
                                                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                                        </svg>


                                                    </div>

                                                    <span
                                                        className="ml-2 xl:text-base md:text-2xl text-base">Ajustes</span>


                                                </div>
                                            </li>

                                        </Link>

                                    </ul>
                                </div>
                                <div className="w-full">
                                    <div className="border-t border-gray-300">
                                        <div className="w-full flex items-center justify-between px-6 pt-5">
                                            <div className="flex items-center">
                                                <img alt="profile-pic"
                                                     src={user.avatar}
                                                     className="w-8 h-8 rounded-md"/>
                                                <p className="md:text-xl text-gray-800 text-base leading-4 ml-2">{getFirstWord(user.name)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Mobile responsive sidebar*/}
                    {/* Sidebar ends */}
                    <div className="w-full bg-gray-100">
                        {/* Navigation starts */}
                        <nav
                            className="h-16 flex items-center lg:items-stretch justify-end lg:justify-between bg-white border-b relative z-10">
                            <div className="hidden lg:flex w-full pr-6">
                                <div className="w-1/2 h-full hidden lg:flex items-center pl-6 pr-24">

                                </div>
                                <div className="w-1/2 hidden lg:flex">
                                    <div className="w-full flex items-center pl-8 justify-end">

                                        <div className="flex items-center relative cursor-pointer"
                                             onClick={() => setProfile(!profile)}>
                                            <div className="rounded-full">
                                                {profile ? (
                                                    <ul className="p-2 w-full border-r bg-white absolute rounded left-0 shadow mt-12 sm:mt-16 ">
                                                        <li onClick={() => handleLogout()}
                                                            className="flex w-full justify-between text-gray-600 hover:text-amber-400 cursor-pointer items-center mt-2">
                                                            <div className="flex items-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                                     className="icon icon-tabler icon-tabler-logout"
                                                                     width={20} height={20} viewBox="0 0 24 24"
                                                                     strokeWidth="1.5" stroke="currentColor"
                                                                     fill="none"
                                                                     strokeLinecap="round" strokeLinejoin="round">
                                                                    <path stroke="none" d="M0 0h24v24H0z"/>
                                                                    <path
                                                                        d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"/>
                                                                    <path d="M7 12h14l-3 -3m0 6l3 -3"/>
                                                                </svg>
                                                                <span className="text-sm ml-2">Cerrar sesión</span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                ) : (
                                                    ""
                                                )}
                                                <div className="relative">
                                                    <img className="rounded-full h-10 w-10 object-cover"
                                                         src={user.avatar}
                                                         alt="avatar"/>
                                                    <div
                                                        className="w-3 h-3 rounded-full bg-green-600 border-2 border-white absolute inset-0 mb-0 mr-0 m-auto"/>
                                                </div>
                                            </div>
                                            <p className="text-gray-800 text-sm mx-3">{getFirstWord(user.name)}</p>
                                            <div className="cursor-pointer text-gray-600">
                                                <svg aria-haspopup="true" xmlns="http://www.w3.org/2000/svg"
                                                     className="icon icon-tabler icon-tabler-chevron-down"
                                                     width={20}
                                                     height={20} viewBox="0 0 24 24" strokeWidth="1.5"
                                                     stroke="currentColor" fill="none" strokeLinecap="round"
                                                     strokeLinejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z"/>
                                                    <polyline points="6 9 12 15 18 9"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-gray-600 mr-8 visible lg:hidden relative"
                                 onClick={() => setShow(!show)}>
                                {show ? (
                                    " "
                                ) : (
                                    <svg aria-label="Main Menu" aria-haspopup="true"
                                         xmlns="http://www.w3.org/2000/svg"
                                         className="icon icon-tabler icon-tabler-menu cursor-pointer" width={30}
                                         height={30} viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                                         fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z"/>
                                        <line x1={4} y1={8} x2={20} y2={8}/>
                                        <line x1={4} y1={16} x2={20} y2={16}/>
                                    </svg>
                                )}
                            </div>
                        </nav>
                        {/* Navigation ends */}
                        {/* Remove class [ h-64 ] when adding a card block */}
                        <div className="container mx-auto py-6 px-6">
                            {/* Remove class [ border-dashed border-2 border-gray-300 ] to remove dotted border */}
                            <div className="w-full h-full ">
                                <Routes>
                                    <Route path="estadisticas" element={<Dashboard/>}/>
                                    <Route path="usuarios" element={<Users/>}/>
                                    <Route path="solicitudes" element={<Requests/>}/>
                                    <Route path="viajes" element={<Trips/>}/>
                                    <Route path="billetera" element={<Wallet/>}/>
                                    <Route path="ajustes" element={<Settings/>}/>
                                </Routes>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
